/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CompanyWebhookEventType } from "./CompanyWebhookEventType";
import {
  CompanyWebhookEventTypeFromJSON,
  CompanyWebhookEventTypeFromJSONTyped,
  CompanyWebhookEventTypeToJSON,
  CompanyWebhookEventTypeToJSONTyped,
} from "./CompanyWebhookEventType";

/**
 *
 * @export
 * @interface WebhookEventTypeInfo
 */
export interface WebhookEventTypeInfo {
  /**
   *
   * @type {CompanyWebhookEventType}
   * @memberof WebhookEventTypeInfo
   */
  eventType: CompanyWebhookEventType;
  /**
   *
   * @type {string}
   * @memberof WebhookEventTypeInfo
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof WebhookEventTypeInfo
   */
  description: string;
}

/**
 * Check if a given object implements the WebhookEventTypeInfo interface.
 */
export function instanceOfWebhookEventTypeInfo(
  value: object,
): value is WebhookEventTypeInfo {
  if (!("eventType" in value) || value["eventType"] === undefined) return false;
  if (!("label" in value) || value["label"] === undefined) return false;
  if (!("description" in value) || value["description"] === undefined)
    return false;
  return true;
}

export function WebhookEventTypeInfoFromJSON(json: any): WebhookEventTypeInfo {
  return WebhookEventTypeInfoFromJSONTyped(json, false);
}

export function WebhookEventTypeInfoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): WebhookEventTypeInfo {
  if (json == null) {
    return json;
  }
  return {
    eventType: CompanyWebhookEventTypeFromJSON(json["eventType"]),
    label: json["label"],
    description: json["description"],
  };
}

export function WebhookEventTypeInfoToJSON(json: any): WebhookEventTypeInfo {
  return WebhookEventTypeInfoToJSONTyped(json, false);
}

export function WebhookEventTypeInfoToJSONTyped(
  value?: WebhookEventTypeInfo | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    eventType: CompanyWebhookEventTypeToJSON(value["eventType"]),
    label: value["label"],
    description: value["description"],
  };
}
